import styled from "styled-components";

const Extra = styled.p`
  margin: 0;
`;

export default Extra;
